import axiosInstance from '../config/axios.js';
import { downloadBlob, filenameFromContentDisposition } from '../utils/downloadBlob.js';

const BASE = '/company-settlements';

const companySettlementService = {
  getSummary: async (params = {}) => {
    const response = await axiosInstance.get(`${BASE}/summary`, { params });
    return response.data;
  },

  listBatches: async (params = {}) => {
    const response = await axiosInstance.get(`${BASE}/batches`, { params });
    return response.data;
  },

  getBatch: async (batchId) => {
    const response = await axiosInstance.get(`${BASE}/batches/${encodeURIComponent(batchId)}`);
    return response.data;
  },

  submitBatch: async (formData) => {
    const response = await axiosInstance.post(`${BASE}/batches`, formData, {
      headers: { 'Content-Type': undefined },
    });
    return response.data;
  },

  approveBatch: async (batchId, payload = {}) => {
    const response = await axiosInstance.post(
      `${BASE}/batches/${encodeURIComponent(batchId)}/approve`,
      payload,
    );
    return response.data;
  },

  rejectBatch: async (batchId, payload = {}) => {
    const response = await axiosInstance.post(
      `${BASE}/batches/${encodeURIComponent(batchId)}/reject`,
      payload,
    );
    return response.data;
  },

  downloadExcel: async (params = {}) => {
    const response = await axiosInstance.get(`${BASE}/statement.xlsx`, {
      params,
      responseType: 'blob',
    });
    const name = filenameFromContentDisposition(
      response.headers?.['content-disposition'],
      'commission_settlement.xlsx',
    );
    downloadBlob(
      response.data,
      name,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    );
  },

  downloadPdf: async (params = {}) => {
    const response = await axiosInstance.get(`${BASE}/statement.pdf`, {
      params,
      responseType: 'blob',
    });
    const name = filenameFromContentDisposition(
      response.headers?.['content-disposition'],
      'commission_settlement.pdf',
    );
    downloadBlob(response.data, name, 'application/pdf');
  },
};

export default companySettlementService;
